
// react
import React, { useEffect } from 'react';
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';

// material-ui icons
import ShoppingCart from "@material-ui/icons/ShoppingCart";

// material-ui components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";

// services
import { getcarrinhoVendaCookie } from "beaktClinic/services/carrinhoVenda";

// style
import styles from "assets/jss/BeaktClinic/views/Venda/headerVenda.js";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(styles);

export default function HeaderVenda() {
    const { t } = useTranslation();
    const classes = useStyles();

    const [qtdItensCarrinho,setqtdItensCarrinho] = React.useState(0);
    let carrinhoVenda = getcarrinhoVendaCookie();
    
    useEffect(() => {   
        if(carrinhoVenda != null)        
            setqtdItensCarrinho(carrinhoVenda.itens.length);
        
    }, [carrinhoVenda]);

return (
    <div>        
        
        <Card>
        <CardBody className={classes.cardHeaderVenda}>  

            <GridContainer>
                <GridItem md={10} xs={10} sm={10}>

                <div className={classes.titlenew}>                 
                {t('sale.new_sale')}
                </div>

                </GridItem>
                <GridItem md={2} xs={2} sm={2}>
                    
                    <div className={classes.boxCar}  >
                        <Link to="/adminclinic/carrinhovenda" >
                            <ShoppingCart className={classes.icoCar} />
                        </Link> 
                        <div className={classes.notificationCar}> 
                         {qtdItensCarrinho}                        
                        </div> 
                    </div>

                </GridItem>
            </GridContainer>  
        
        </CardBody>
        </Card>

    </div>
);
}